<template>
  <a-form :form="form">
    <a-form-item label="Müraciətin qısa məzmunu">
      <a-textarea v-decorator="[
        'title',
        {
          rules: [
            { required: true, message: 'Müraciətin qısa məzmunu daxil edilməlidir.' },
            { max: 150, message: 'Başlıq maksimum 150 simvol ola bilər' },
          ],
        },
      ]" />
    </a-form-item>

    <a-form-item label="Yerli icra hakimiyyəti orqanı">
      <a-select showSearch :filterOption="false" @change="handleExecutiveChange" allowClear v-decorator="[
        'executiveId',
        {
          rules: [
            {
              required: true,
              message: 'Yerli icra hakimiyyəti orqanı mütləq seçilməlidir.',
            },
          ],
        },
      ]" @search="searchExecutives" :disabled="isJoined">
        <a-select-option v-for="(exec, index) in filterExecutives" :key="index" :value="exec.id">
          {{ exec.name }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item label="Qurumlar">
      <a-select showSearch :filterOption="false" mode="multiple"
        v-decorator="[
          'execStrIds',
          {
            rules: [
              {
                required: true,
                message: 'Qurum mütləq seçilməlidir.',
              },
            ],
          },
        ]" @search="searchOffices" autoClearSearchValue>
        <a-select-option v-for="(off, index) in filterOffices" :disabled='slctdStrIDs.indexOf(off.id) > -1' :key="index"
          :value="off.id">
          {{ off.categorySelectionRequired ? off.name + ", təsnifat zəruridir " + getRedirectionText(off) : off.name + " " +
            getRedirectionText(off) }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item label="Müraciətin ünvanı">
      <a-input v-decorator="['address']" :disabled="isJoined" :maxLength="250" />
    </a-form-item>

    <a-form-item label="Müraciətin təsnifatı">
      <a-tree-select
        :disabled="isJoined"
        showSearch
        v-decorator="['selCatIds', { rules: [{ required: true, message: 'Müraciətin təsnifatı mütləq seçilməlidir.' }] }]"
        style="width: 100%"
        allow-clear
        multiple
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        placeholder="Müraciətin təsnifatı seçin"
        @change="onChange"
        tree-checkable
        :show-checked-strategy="SHOW_PARENT"
        tree-node-filter-prop="title"
        tree-node-label-prop="title"
      >
        <!-- Ana kateqoriya: value-su xüsusi 'cat_' prefiksi ilə ki, alt kateqoriya ilə toqquşmasın -->
        <a-tree-select-node
          v-for="cat in filterCategories"
          :key="'cat_' + cat.uuid"
          :value="'cat_' + cat.uuid"
          :title="cat.name"
          :selectable="false"
          :disableCheckbox="true"
        >
          <!-- Alt kateqoriyalar: value xam uuid olaraq qalır ki, v-decorator dəyəri tanıya bilsin -->
          <a-tree-select-node
            v-for="subcat in cat.subCategories"
            :key="'scat_' + subcat.uuid"
            :value="subcat.uuid"
            :title="subcat.name"
          >
            <a-tree-select-node
              v-for="sscat in subcat.subCategories"
              :key="'sscat_' + sscat.uuid"
              :value="sscat.uuid"
              :title="sscat.name"
            >
            </a-tree-select-node>
          </a-tree-select-node>
        </a-tree-select-node>
      </a-tree-select>
    </a-form-item>

    <a-form-item label="Prioritetlik">
      <a-radio-group :disabled="isJoined" v-decorator="[
        'priorityLevel',
        {
          rules: [{ required: true, message: 'Prioritetlik mütləq seçilməlidir.' }],
        },
      ]" buttonStyle="solid">
        <a-radio-button v-for="pr in priorityLevels" :class="pr.color" :value="pr.name" :key="pr.name">{{ pr.title
        }}</a-radio-button>
      </a-radio-group>
    </a-form-item>

    <a-form-item label="Müraciətin növü">
      <a-select :disabled="isJoined" v-decorator="[
        'type',
        {
          rules: [{ required: true, message: 'Müraciət növü seçilməyib' }],
        },
      ]">
        <a-select-option value="COMPLAINT">Şikayət</a-select-option>
        <a-select-option value="OFFER">Təklif</a-select-option>
        <a-select-option value="diger">Digər</a-select-option>
      </a-select>
    </a-form-item>
  </a-form>
</template>

<script>
import { URL, apiCall } from "@/utils/api";
import mixin from "@/mixins/index";
import { TreeSelect } from "ant-design-vue";

const SHOW_PARENT = TreeSelect.SHOW_PARENT;

export default {
  name: "CitProblemForm",
  props: {
    title: String,
    executive: Object,
    priorityLevel: String,
    type: String,
    address: String,
    cats: Array,
    execs: Array,
    isJoined: Boolean,
    request: Object,
  },
  mixins: [mixin],
  data() {
    console.log(this.title, 'testtetetete');
    return {
      slctdStrIDs: [],
      form: this.$form.createForm(this, { name: "coordinated" }),
      executives: [],
      filterExecutives: [],
      vtitle: this.title,
      vexecutive: this.executive,
      vaddress: this.address,
      vpriority: this.priority,
      strSearchTimeout: null,
      category: null,
      filterCategories: [],
      categoriesAll: [],
      execOffices: [],
      filterOffices: [],
      SHOW_PARENT,

    };
  },
  methods: {
    async submit() {
      try {
        let values = await this.form.validateFields();


        let execStructures = values.execStrIds.map((item) => {
          return { id: item };
        });

        return {

          title: values.title,
          executive: { id: values.executiveId },
          address: values.address,
          priorityLevel: values.priorityLevel,
          type: values.type,
          execStructures: execStructures,
          categories: values.selCatIds.map((it) => {
            return { uuid: it };
          }),
        };
      } catch (error) {

        this.$message.warn(
          "Vacib məlumatlar daxil edilməlidir."
        );
        console.log(error);
        return null;
      }
    },
    searchExecutives(v) {
      const regex = new RegExp(v, "i");
      this.filterExecutives = this.executives.filter((item) =>
        regex.test(item.name.toLowerCase())
      );
    },
    searchCategoriesByStructure(categoryList, strIds) {

      return categoryList.filter(item => item.structure && strIds.indexOf(item.structure.id) > -1)
    },
    mergeMissingCategories() {
      const existingUuids = new Set(this.filterCategories.map(item => item.uuid));

      const newCategories = this.cats.filter(item => !existingUuids.has(item.uuid));

      this.filterCategories.push(...newCategories);
    },
    getRedirectionText(off) {
      return off.relatedMinistry && off.relatedMinistry.askForRedirection
        ? `(${off.relatedMinistry.name} təşkilatına yönləndiriləcək)`
        : "";
    },
    searchOffices(search) {
      const regex = new RegExp(search, "i");
      this.filterOffices = this.execOffices.filter((office) =>
        regex.test(office.name.toLowerCase())
      );
    },
    handleExecutiveChange(val) {
      let executve = this.executives.find((item) => item.id == val);
      if (executve && (!this.address || this.address.trim().length == 0)) {
        this.form.setFieldsValue({ address: this.address });
      }
    },
    onLoadData(treeNode) { },
    handlePCatChange(val) {
      this.category = this.filterCategories.find((item) => item.id === val);
      this.form.setFieldsValue({ subCatId: null });
    },
    getExecStructures() {
      apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "structures/execStructures",
        method: "GET",
      })
        .then((response) => {
          if (!response.data.error) {
            this.execOffices = response.data.data.entities;
          }
          this.filterOffices = this.execOffices;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategoryList(isNew=true) {
      this.getCategories(isNew).then((response) => {
        if (!response.data.error) {

          this.filterCategories = response.data.data.entities;
          this.mergeMissingCategories();

        }
      });
    },
    onChange(value) {
      // console.log(value);
    },
    fillForm() {
      this.mergeMissingCategories();
      this.form.setFieldsValue({
        title: this.title,
        executiveId: this.executive ? this.executive.id : null,
        address: this.address,
        priorityLevel: this.priorityLevel,
        type: this.type ? this.type : "COMPLAINT",
        execStrIds: this.execs ? this.execs.map((item) => item.id) : [],
        selCatIds: this.cats
          ? this.cats.map((item) => item.uuid)
          : [],
      });
    },
  },
  watch: {
    request: function () {

    },
    execs: function () {
      this.slctdStrIDs = this.execs ? [...this.execs.map((item) => item.id)] : []
      this.form.setFieldsValue({

        execStrIds: this.slctdStrIDs
      })
    },

    cats: function () {
      this.mergeMissingCategories();

      this.form.setFieldsValue({
        selCatIds: this.cats
          ? this.cats.map((item) => item.uuid)
          : [],
      });
    },
    title: function () {

      this.form.setFieldsValue({
        title: this.title,
      });
    },
    priorityLevel: function (newV, oldV) {
      console.log('watch', this.priorityLevel);
      this.form.setFieldsValue({
        executiveId: this.executive.id,
        address: this.address,
        priorityLevel: this.priorityLevel,
        type: this.type ? this.type : "COMPLAINT",
      });
    },
    request: function () {
      this.fillForm();
    },
  },
  created() {
    this.getExecutives();
    this.getExecStructures();
    this.getCategoryList();
  },
  mounted() {
    this.fillForm();
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style scoped>
 /* Ana nodun checkbox-ını gizlədir */
:deep(.parent-node-no-checkbox > .ant-select-tree-checkbox) {
  display: none !important;
}

/* Label-in kliklənməyən görünüş alması üçün */
:deep(.parent-node-no-checkbox > .ant-select-tree-node-content-wrapper) {
  cursor: default !important;
  font-weight: bold;
}
</style>